import tmhRequest from '@/config/tmhRequest'

export default {
    searchCustomerClassifyReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/customerclassifyreport/searchcustomerclassifyreportcount',
            method: 'post',
            data: data,
        })
    },
    searchCustomerClassifyReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/customerclassifyreport/searchcustomerclassifyreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportCustomerClassifyReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/customerclassifyreport/exportcustomerclassifyreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/customerclassifyreport.js